<template>
  <div class="page-home">
    <Header path="/"></Header>
    <div class="home-adCarousel">
      <swiper ref="mySwiper" :options="swiperOptions">
        <swiper-slide>
          <div class="adCarousel-item adCarousel-item-4"></div>
        </swiper-slide>
        <swiper-slide>
          <div class="adCarousel-item adCarousel-item-1" @click="jump('/try')"></div>
        </swiper-slide>
        <swiper-slide>
          <div class="adCarousel-item adCarousel-item-2" @click="jump('/productCenter')"></div>
        </swiper-slide>
        <swiper-slide>
          <div class="adCarousel-item adCarousel-item-3" @click="jump('/productDetails')"></div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div class="home-company">
        <h3>重庆神缘智能科技有限公司</h3>
        <p>
          重庆神缘智能科技有限公司是一家专业从事物联网燃气表及智能燃气管理平台研发、生产的高新技术企业。公司拥有一支专业研发和具备多年燃气行业管理经验的团队，深耕物联网燃气表、智能燃气管理平台相关核心技术研究。公司以客户为中心，以激情铸就辉煌为宗旨，以热情、诚信服务为理念，致力于物联网技术的研发，积极探索智慧燃气领域创新发展，着力打造 “渝神缘” 品牌。
        </p>
        <div class="line"></div>
        <p>以客户为中心，以激情铸就辉煌</p>
    </div>
    <div class="home-propaganda ui-flex ui-flex-justify-center ui-flex-align-center" >
         <video
          class="shade-propaganda"
          poster="./propaganda.png"
          controls="controls"
          controlsList="nodownload"
          src="http://easygas-other.oss-cn-beijing.aliyuncs.com/propaganda.mp4"
          width="800"
        ></video>
    </div>
    <div class="home-about">
      <div class="about-title-wrap ui-flex ui-flex-justify-center">
        <div
          class="about-title ui-flex ui-flex-justify-center ui-flex-align-center"
          @click="jump('/about')"
        >
          关于我们
          <i class="title-icon"></i>
        </div>
      </div>
      <div class="ui-flex ui-flex-justify-center">
        <div class="ele-wrap about-content ui-flex ui-flex-justify-space-between">
          <div class="content-part1"></div>
          <div class="content-part2 ui-flex ui-flex-column">
            <div class="part2-title">致力产品及软件服务</div>
            <div
              class="part2-content"
            >物联网燃气表和智能燃气管理平台的研发，用其精准的燃气计量，安全的防磁技术以及智能燃气管理平台的兼容性，收费系统的准确性、稳定性，以及办公的便捷性，极大改善了燃气企业存在的现有问题。</div>
            <div class="content-more-wrap ui-flex ui-flex-justify-end">
              <div
                class="content-more ui-flex ui-flex-justify-center ui-flex-align-center"
                @click="jump('/productCenter')"
              >
                更多产品
                <i class="title-icon"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="home-cooperation ui-flex ui-flex-justify-center">
      <div class="ele-wrap ui-flex ui-flex-justify-center ui-flex-align-center">
        <ul class="cooperation-part1">
          <li class="part1-li">合</li>
          <li class="part1-li">作</li>
          <li class="part1-li">伙</li>
          <li class="part1-li">伴</li>
        </ul>
        <div class="cooperation-part2">
          <swiper ref="mySwiper" :options="swiperOptions2">
            <swiper-slide>
              <ul class="part2-list ui-flex">
                <li class="part2-list-li part2-list-li-1"></li>
                <li class="part2-list-li part2-list-li-2"></li>
                <li class="part2-list-li part2-list-li-3"></li>
              </ul>
            </swiper-slide>
            <swiper-slide>
              <ul class="part2-list ui-flex">
                <li class="part2-list-li part2-list-li-4"></li>
                <li class="part2-list-li part2-list-li-5"></li>
                <li class="part2-list-li part2-list-li-6"></li>
              </ul>
            </swiper-slide>
            <swiper-slide>
              <ul class="part2-list ui-flex">
                <li class="part2-list-li part2-list-li-7"></li>
                <li class="part2-list-li part2-list-li-8"></li>
                <li class="part2-list-li part2-list-li-9"></li>
              </ul>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
      </div>
    </div>

    <Footer></Footer>

  </div>
</template>

<script>
import Header from "@/components/Header/index.vue";
import Footer from "@/components/Footer/index.vue";
import router from "@/router";
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default {
  components: {
    Swiper,
    SwiperSlide,
    Header,
    Footer
  },
  directives: {
    swiper: directive
  },
  data() {
    return {
      //banner轮播图
      swiperOptions: {
        speed: 1000,
        height: 650,
        autoplay: true,
        autoplay: {
          disableOnInteraction: false
        },
        autoplayStopOnLast: false,
        pagination: {
          el: ".swiper-pagination"
        }
      },
      //合作伙伴轮播图
      swiperOptions2: {
        autoplay: true,
        autoplay: {
          disableOnInteraction: false
        },
        autoplayStopOnLast: false,
        direction: "vertical",
        width: 298,
        height: 200,
        pagination: {
          el: ".swiper-pagination"
        }
      },

    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    }
  },
  mounted() {},
  methods: {
    /**
     * 点击跳转
     */
    jump(value) {
      router
        .push({
          path: value
        })
        .catch(err => {
          console.log(err);
        });
    },

  }
};
</script>
<style lang="sass">
@import "./style.scss"
</style>